import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StarIconComponent } from '../../../app/core/svg-icons/star-icon.component';

const meta: Meta<StarIconComponent> = {
  title: 'Atoms/Icons/StarIcon',
  component: StarIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A star icon component rendered as SVG. Perfect for ratings, favorites, and highlights.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StarIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-star-icon></app-star-icon>',
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-star-icon')).toBeTruthy();
  },
};

export const Multiple: Story = {
  render: () => ({
    template: `
      <div style="display: flex; gap: 0.5rem; align-items: center;">
        <app-star-icon></app-star-icon>
        <app-star-icon></app-star-icon>
        <app-star-icon></app-star-icon>
        <app-star-icon></app-star-icon>
        <app-star-icon></app-star-icon>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Multiple star icons in a row - commonly used for ratings display.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-star-icon')).toBeTruthy();
  },
};

export const InText: Story = {
  render: () => ({
    template: `
      <div style="font-size: 18px; line-height: 1.5;">
        This product has a <app-star-icon></app-star-icon> rating and is highly recommended.
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Star icon used inline with text content.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-star-icon')).toBeTruthy();
  },
};

export const DifferentSizes: Story = {
  render: () => ({
    template: `
      <div style="display: flex; flex-direction: column; gap: 1rem; align-items: flex-start;">
        <div style="font-size: 12px;">
          Small: <app-star-icon></app-star-icon>
        </div>
        <div style="font-size: 16px;">
          Normal: <app-star-icon></app-star-icon>
        </div>
        <div style="font-size: 24px;">
          Large: <app-star-icon></app-star-icon>
        </div>
        <div style="font-size: 32px;">
          Extra Large: <app-star-icon></app-star-icon>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Star icon scales with parent font-size due to its SVG nature.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-star-icon')).toBeTruthy();
  },
};
